export default __webpack_public_path__ + "static/media/gallery_02.d62a40ec.jpg";